import { gql } from "@apollo/client";

export const COMPLETE_MULTIPART_UPLOAD = gql`
  mutation CompleteMultipartUpload($input: MultipartUploadCompleteInput!) {
    completeMultipartUpload(input: $input) {
      type
      fileId
      objectKey
      status
      eventId
      url
    }
  }
`;
